import { createContext, useContext, useEffect, useState } from "react";
import { fbTrack } from "@/lib/fbpixel";

const CartContext = createContext(null);
const KEY = "wiggles_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [lastAdd, setLastAdd] = useState(null);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const addItem = (product, quantity = 1, opts = {}) => {
    const { color = null, size = null } = opts;
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) {
        return prev.map((i) => i.product_id === product.id
          ? { ...i, quantity: i.quantity + quantity, color: color ?? i.color, size: size ?? i.size }
          : i);
      }
      return [...prev, {
        product_id: product.id, name: product.name, price: product.price,
        image: (product.images || [])[0] || "", quantity, color, size,
        shopify_variant_id: product.shopify_variant_id || "",
      }];
    });
    setLastAdd({ id: Date.now(), name: product.name, image: (product.images || [])[0] || "", price: product.price });
    fbTrack("AddToCart", { content_name: product.name, content_type: "product", content_ids: [product.id], value: (product.price || 0) * quantity, currency: "USD" });
  };

  const removeItem = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));
  const setQty = (pid, qty) => setItems((prev) => prev.map((i) => i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i));
  const clear = () => setItems([]);

  const count = items.reduce((n, i) => n + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, setQty, clear, count, total, lastAdd }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
